import { render, staticRenderFns } from "./mytna.vue?vue&type=template&id=6318499f"
import script from "./mytna.vue?vue&type=script&lang=js"
export * from "./mytna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports